// @ts-check

import React from 'react';

import { formatDate } from 'core/utils';

/** @type {TableColumn} */
const cloneColumn = {
  id: 'clone_campaign',
  text: '',
  render: ({ row, col, cellValue, id, onClick }) => (
    <button
      type="button"
      className="clone-campaign-link btn btn-link p-0 fw-normal d-inline-flex align-items-center gap-1 text-decoration-underline"
      data-ga-event="link"
      data-ga-action="click"
      data-ga-name="onclick"
      data-ga-type="internal link"
      data-ga-region="main content"
      data-ga-section="Campaign Search"
      data-ga-component=""
      data-ga-text={`Clone campaign: ${/** @type {any} */ (row).name}`}
      aria-label={`Clone campaign ${/** @type {any} */ (row).name}`}
      onClick={() => {
        onClick({ row, col, cellValue, id });
      }}
    >
      <i className="fa-regular fa-copy" aria-hidden="true" />
      <span>Clone</span>
    </button>
  ),
  textAlign: 'center',
};

/** @type {TableColumn[]} */
const baseColumns = [
  {
    id: 'name',
    text: 'Campaign Name',
    width: '250px',
    cellStyle: {
      fontWeight: 'bold',
    },
  },
  {
    id: 'created_at',
    text: 'Date Created',
    format: (value) => formatDate(value),
  },
  {
    id: 'created_by',
    text: 'Created By',
  },
  {
    id: 'published',
    text: 'Status',
    dataType: 'boolean',
    componentType: 'badge',
    format: (value) => (value ? 'Published' : 'Saved'),
    computedValue: (value) => (value ? 'text-bg-success' : 'text-bg-info'),
  },
  {
    id: 'view_details',
    text: '',
    render: ({ row, col, cellValue, id, onClick }) => (
      <button
        type="button"
        className="btn btn-sm btn-dark"
        data-ga-event="link"
        data-ga-action="click"
        data-ga-name="onclick"
        data-ga-type="internal link"
        data-ga-region="main content"
        data-ga-section="Campaign Search"
        data-ga-component=""
        data-ga-text={`View details for campaign: ${
          /** @type {any} */ (row).name
        }`}
        aria-label={`View details for campaign ${
          /** @type {any} */ (row).name
        }`}
        onClick={() => {
          onClick({ row, col, cellValue, id });
        }}
      >
        View Details
      </button>
    ),
    textAlign: 'center',
  },
];

/**
 * @param {{ enableCloneColumn?: boolean }} param0
 * @returns {TableConfig}
 */
const buildCampaignTableConfig = ({ enableCloneColumn = false }) => {
  if (!enableCloneColumn) {
    return {
      columns: baseColumns,
      clientSorting: true,
      rowKeyId: 'campaign_id',
    };
  }

  const viewDetailsIndex = baseColumns.findIndex(
    (col) => col.id === 'view_details',
  );
  const columns = [...baseColumns];
  if (viewDetailsIndex === -1) {
    columns.push(cloneColumn);
  } else {
    columns.splice(viewDetailsIndex, 0, cloneColumn);
  }

  return {
    columns,
    clientSorting: true,
    rowKeyId: 'campaign_id',
  };
};

/** @type {TableConfig} */
const campaignTableConfig = buildCampaignTableConfig({});

export { buildCampaignTableConfig, campaignTableConfig };
